import React from 'react';
import Link from 'next/link';
import Slider from 'react-slick';

const AIEnabledAgriculture = () => {
    const testimonialsettings = {
        dots: true,
        arrow: true,
        autoplay: false,
        speed: 500, // Set slide transition speed
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-3" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            AI-Enabled Agriculture Software Development Services
                        </h2>
                        <p className="text-textcolor mb-0">
                            Modern farming demands more than just data, it needs intelligence. Our AI-enabled agriculture software
                            development services help you automate decision-making, optimize resources, and stay resilient in a
                            changing climate.
                        </p>
                    </div>
                </div>

                <div className="section pb-16 dark:bg-black case-study-slider-img ai-enabled-slider">
                    <div className="container-fluid lg:container-fluid mx-auto">
                        <Slider {...testimonialsettings} data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                            <div>
                                <div className="lg:mx-4 md:mx-4 mx-0">
                                    <div className="card rounded-10 bg-white border hover:border-[#00B050]">
                                        <div className="bg-drone-management bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                Drone Automation
                                            </p>
                                        </div>
                                        <div className="p-5">
                                            <p className="text-secondary mb-0 fs-md min-h-[125px]">
                                                Deploy drones for real-time crop mapping, aerial scouting, and precision
                                                spraying—powered by AI-driven flight path optimization and image analysis. These
                                                are key components in our Custom Agriculture Software Solutions.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="lg:mx-4 md:mx-4 mx-0">
                                    <div className="card rounded-10 bg-white border hover:border-[#00B050]">
                                        <div className="bg-smart-iot-management bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                Smart IoT Sensors
                                            </p>
                                        </div>
                                        <div className="p-5">
                                            <p className="text-secondary mb-0 fs-md min-h-[125px]">
                                                Get live data from your fields—temperature, soil moisture, humidity, and more—so
                                                you can act before problems escalate.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="lg:mx-4 md:mx-4 mx-0">
                                    <div className="card rounded-10 bg-white border hover:border-[#00B050]">
                                        <div className="bg-smart-agriculture-management bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                Smart Agriculture Solutions
                                            </p>
                                        </div>
                                        <div className="p-5">
                                            <p className="text-secondary mb-0 fs-md min-h-[125px]">
                                                Unify your farm&apos;s digital ecosystem with integrated tools that automate
                                                workflows, reduce manual errors, and provide actionable insights.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="lg:mx-4 md:mx-4 mx-0">
                                    <div className="card rounded-10 bg-white border hover:border-[#00B050]">
                                        <div className="bg-machine-learning-management bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                Machine Learning for Disease Diagnosis
                                            </p>
                                        </div>
                                        <div className="p-5">
                                            <p className="text-secondary mb-0 fs-md min-h-[125px]">
                                                Detect plant diseases early using computer vision models trained on thousands of
                                                images—cutting down loss and response time.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="lg:mx-4 md:mx-4 mx-0">
                                    <div className="card rounded-10 bg-white border hover:border-[#00B050]">
                                        <div className="bg-ai-driven-crop-management bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                AI-Driven Crop and Soil Monitoring
                                            </p>
                                        </div>
                                        <div className="p-5">
                                            <p className="text-secondary mb-0 fs-md min-h-[125px]">
                                                Monitor crop stress, forecast yield, and assess soil health with predictive AI
                                                models that adapt to your local farming conditions. A critical part of our
                                                agriculture software development services for sustainable growth.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="lg:mx-4 md:mx-4 mx-0">
                                    <div className="card rounded-10 bg-white border hover:border-[#00B050]">
                                        <div className="bg-intelligent-management bg-cover bg-no-repeat bg-center h-[130px] rounded-t-10 flex">
                                            <p className="text-white font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                Intelligent Agriculture Cloud
                                            </p>
                                        </div>
                                        <div className="p-5">
                                            <p className="text-secondary mb-0 fs-md min-h-[125px]">
                                                Centralize data from drones, IoT, and sensors into a secure cloud platform—turning
                                                scattered inputs into strategic insights. Ideal for enterprises seeking advanced
                                                Agriculture IT Solutions with centralized control.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 pt-10">
                    <div className="lg:col-span-12">
                        <h2 className="mb-3 text-primary_one">
                            Ready to Join the Future of Smarter Agriculture Software Development?
                        </h2>
                        <p className="mb-3">
                            Let&apos;s turn your AgTech vision into a reality—with AI, automation, and real-world impact.
                        </p>
                        <div>
                            <Link
                                href="/contact-us"
                                className="btn btn-primary bg-[#00B050] border-[#00B050] hover:border-[#00B050]"
                            >
                                {'Get in Touch with Our AgTech Experts'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AIEnabledAgriculture;
